import * as Yup from 'yup';

export const technicalDocsSchema = Yup.object().shape({
  file_name: Yup.string(),
});
